import React, { useEffect, useState } from 'react'
import {PDFDownloadLink} from '@react-pdf/renderer'
import ModalPDFReimprimirDespachos from './ModalPDFReimprimirDespachos'
import { postPDFReimprimirDespachos } from '../../../services/FarmaciaRuta'
import ErrorEndpointComponent from '../../Error/ErrorEndpointComponent'
import { desencriptarData } from '../../../services/encryption'
import { postUsuarioQuienEntregaDespachos } from '../../../services/PaginaRuta'

const ModalConfirmarReimprimirDespachos = ({setmodalOnPDFReimprimirDespachos,dataUser}) => {
    const [infoPDFReimprimirDespacho, setinfoPDFReimprimirDespacho]=useState([])
    const [errorEndpoint, seterrorEndpoint]=useState(false)
    const [usuarioEntrega, setusuarioEntrega]=useState({
      "AUsrId": "",
      "AUsrDsc": ""
    })
    const [usuarioRecibe, setusuarioRecibe]=useState({
      "AUsrId": "",
      "AUsrDsc": ""
    })
    const [dataUserPDF, setdataUserPDF]=useState({
        ClaPro: "",
        CncCd: "",
        CncDes: "",
        DSCodDoc: "",
        DSmCnsMov: "",
        DSmCntDes: "",
        DSmCntDsp: "",
        DSmCntMov: "",
        DSmEst: "",
        DSmFHrMov: "",
        DSmTpoTrn: "",
        DSmUsrMov: "",
        DSmUsrReg: "",
        DsBodSal: "",
        DsEmpCod: "",
        DsNumDoc: "",
        DsmTipDsp: "",
        FSmDscUMd: "",
        HISCKEY: "",
        HISCSEC: "",
        HISTipDoc: "",
        MPFchN: "",
        MPNOMC: "",
        MPSexo: "",
        MSForm: "",
        MSNomG: "",
        MSRESO: "",
        MarCod: "",
        MsUndDes: "",
        TFCedu: "",
        TFMENi: "",
        TFNomCto: "",
        TFTDoc: "",
        TFcCodCam: "",
        TFcCodPab: "",
        TFcNomPab: "",
        TFcPrCm: "",
        TmCtvIng: ""

    })
    const [loading,setloading]=useState(true)
    const handleCancelarClick=()=>{
        setmodalOnPDFReimprimirDespachos(false)
    }
    const handleOnclickConfirmarPDF=()=>{
      setTimeout(() => {          
        setmodalOnPDFReimprimirDespachos(false)
      }, 500);
    }
    useEffect(()=>{
      console.log(dataUser,'dataUserdataUser')
      setloading(false)
        const infoPDF={
            "HISCKEY" : dataUser.HISCKEY,
            "HISTipDoc" : dataUser.HISTipDoc,
            "HISCSEC" : dataUser.HISCSEC,
            "DSmTpoTrn" : dataUser.DSmTpoTrn
        }
        //console.log(infoPDF,'infoPDF')
        postPDFReimprimirDespachos(infoPDF).then((res)=>{
            //console.log(res.data,'data pdf reimprimir')
            
            setTimeout(() => {          
              setloading(true)
            }, 1500);
            //if(res.data){
              //console.log(res.data, 'dataaaaa')
              setinfoPDFReimprimirDespacho(res.data.SuministroDatos)
              setdataUserPDF(res.data.DatosGenerales)
              //console.log(res.data[0].DSmUsrMov,'desencriptarData antes')
              //console.log(desencriptarData(res.data[0].DSmUsrMov),'desencriptarData despues')
              let usuarioQuienEntrega = {
                //"AUsrId":desencriptarData(res.data.DatosGenerales.DSmUsrMov.trim())
                "AUsrId":res.data.DatosGenerales.DSmUsrMov? res.data.DatosGenerales.DSmUsrMov.trim():null
              }
              console.log(usuarioQuienEntrega, ' documento usuarioQuienEntrega')
              postUsuarioQuienEntregaDespachos(usuarioQuienEntrega).then((res)=>{
                console.log(res.data,'usuario quien entrega')
                if(res.data.length !== 0){
                  //setusuarioEntrega(res.data[0])
                  setusuarioEntrega({
                    "AUsrId": desencriptarData(res.data[0].AUsrId.trim()),
                    "AUsrDsc": desencriptarData(res.data[0].AUsrDsc.trim())
                  })
                }else{
                  setusuarioEntrega({
                    "AUsrId": "",
                    "AUsrDsc": "USUARIO NO ESPECIFICADO"
                  })
                }
              })
              let usuarioQuienRecibe = {
                //"AUsrId":desencriptarData(res.data.DatosGenerales.DSmUsrReg.trim())
                "AUsrId":res.data.DatosGenerales.DSmUsrReg? res.data.DatosGenerales.DSmUsrReg.trim() : null
              }
              console.log(usuarioQuienRecibe, ' documento usuarioQuienRecibe')
              postUsuarioQuienEntregaDespachos(usuarioQuienRecibe).then((res)=>{
                console.log(res.data,'usuario usuarioQuienRecibe')
                if(res.data.length !== 0){
                  //setusuarioRecibe(res.data[0])
                  setusuarioRecibe({
                    "AUsrId": desencriptarData(res.data[0].AUsrId.trim()),
                    "AUsrDsc": desencriptarData(res.data[0].AUsrDsc.trim())
                  })
                }else{
                  setusuarioRecibe({
                    "AUsrId": "",
                    "AUsrDsc": "USUARIO NO ESPECIFICADO"
                  })
                }
              })
            //}
            // else{
            //   console.log(res.data)
            //   setinfoPDFReimprimirDespacho(res.data)
            //   setdataUserPDF(res.data[0])
            // }
        })
        .catch((error)=>{
          console.error(error,'error')
          seterrorEndpoint(true)
        })
    },[])
  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-slate-900 bg-opacity-25"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
      <div className="sm:h-[calc(100%-3rem)] max-w-2xl my-6 mx-auto relative w-auto pointer-events-none ">
        <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md bg-[#437cdc]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
              Mensaje
            </h5>
            <button
              type="button"
              onClick={handleCancelarClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
          <div className="flex-auto overflow-y-auto relative p-4">
            <div className="flex py-2 text-left">
              <div className="w-3/3  px-4">
                <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                  Numero de Folio {dataUser.HISCSEC} y Formulado por {dataUser.MMNomM? dataUser.MMNomM.trim():null}. Descargar PDF !!
                  
                </label>
              </div>
            </div>
          </div>
          <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-4 border-t border-gray-200 rounded-b-md">
            <button
              type="button"
              onClick={handleCancelarClick}
              className="inline-block px-6 py-2.5 bg-purple-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              No
            </button>
            <PDFDownloadLink document={<ModalPDFReimprimirDespachos infoPDFReimprimirDespacho={infoPDFReimprimirDespacho} dataUserPDF={dataUserPDF} usuarioEntrega={usuarioEntrega} dataUser={dataUser} usuarioRecibe={usuarioRecibe}/>} fileName='reimprimirdespachoollllllIIIllllllll.pdf'>
            <button
              type="button"
              onClick={handleOnclickConfirmarPDF}
              className="inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
            >
              Si
            </button>
            </PDFDownloadLink>
          </div>
          {errorEndpoint && <ErrorEndpointComponent seterrorEndpoint={seterrorEndpoint} />}
        </div>
        
      </div>
      {
                              loading?
                              null:
                              <div className="relative flex items-center justify-center h-screen">      
                                  <div className="fixed top-0 left-0 flex items-center justify-center w-full h-full bg-slate-900 bg-opacity-25">
                                    <div className="flex flex-col items-center justify-center p-6 bg-white rounded shadow-lg">
                                      <div className="w-16 h-16 border-t-4 border-blue-500 rounded-full animate-spin"></div>
                                      <p className="mt-4 text-lg">Cargando</p>
                                    </div>
                                  </div>                              
                                </div>
                            }   
                            
    </div>
  )
}

export default ModalConfirmarReimprimirDespachos